import { Button } from '@qr-front/ui/components/Button'
import * as ToggleGroup from '@radix-ui/react-toggle-group'

import { TAddressType } from './addressSchema'

export const AddressTypeButton = ({
	value,
	label,
	isSelected,
	onClick,
}: {
	value: TAddressType
	label: string
	isSelected: boolean
	onClick: () => void
}) => (
	<ToggleGroup.Item value={value} asChild>
		<Button
			type="button"
			visual={isSelected ? 'default' : 'secondary'}
			onClick={(event) => {
				event.preventDefault()
				onClick()
			}}
			className="type-body-medium grow [flex-basis:0] tablet:grow-0"
		>
			{label}
		</Button>
	</ToggleGroup.Item>
)
